import { render } from "./ChildEdit.vue?vue&type=template&id=08b7f749&scoped=true&ts=true"
import script from "./ChildEdit.vue?vue&type=script&lang=ts"
export * from "./ChildEdit.vue?vue&type=script&lang=ts"

import "./ChildEdit.vue?vue&type=style&index=0&id=08b7f749&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08b7f749"]])

export default __exports__